import { Button, ChakraSelect, FormControl, FormLabel, HStack, Stack, useBoolean, useDisclosure } from '@elkaso-app/web-design';
import { BaseFilterButton } from 'components/base-table/filters';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

type TOption = { value: string; label: string };
type TInputs = { status: TOption | undefined };

const statusOptions: TOption[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'uploading', label: 'Uploading' },
  { value: 'uploaded', label: 'Uploaded' },
  { value: 'processing', label: 'Processing' },
  { value: 'processed', label: 'Processed' },
  { value: 'validated', label: 'Validated' },
  { value: 'failed', label: 'Failed' },
];

export const InvoiceScanStatusFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  useEffect(() => {
    if (params.status) setIsActive.on();
    else setIsActive.off();
  }, [params.status]);

  const { control, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { status: undefined },
  });

  const updateValues = () => {
    setValue('status', statusOptions.find((o) => o.value === params?.status));
  };

  useEffect(() => {
    updateValues();
  }, [params.status]);

  const onSubmit = (data: TInputs) => {
    params.status = data.status?.value as string;
    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name='status'
            render={({ field: { onChange, name, onBlur, value } }) => (
              <FormControl>
                <FormLabel>Processing Status</FormLabel>
                <ChakraSelect options={statusOptions} onChange={onChange} name={name} onBlur={onBlur} value={value} />
              </FormControl>
            )}
          />
          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>Cancel</Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={!Object.keys(formState.dirtyFields).length}>Filter</Button>
          </HStack>
        </Stack>
      }
    />
  );
};
